//core
import { useDispatch } from "react-redux";

import {
  getAgentStatReportSettingsData,
  clearAgentStatReportState,
} from "./index";

export const useReportsSettings = () => {
  const dispatch = useDispatch<any>();

  const getAgentStatReportSettings = (data: any) => dispatch(getAgentStatReportSettingsData(data));
  const clearAgentStatReport = () => dispatch(clearAgentStatReportState());


  return {
    getAgentStatReportSettings,
    clearAgentStatReport,
  }
};
